import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const SleepPage = lazy(() => import("./SleepPage"));

const SleepPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SleepPage />
    </Suspense>
  );
};

export default SleepPageLazy;
